<template lang="html">
  <div id="gallery" v-if="!imageError" class="p30">
    <div v-swiper:mySwiper="swiperOption">
      <div class="swiper-wrapper" v-viewer="lightBoxOptions">
        <img :key="`img-${i}`" :src="img.cURL" :alt="type.cMerknaam + ' ' + type.cModelnaam" @click="reportEvent('CarImageGallery')" class="swiper-slide col-md-6 col-xl-4 p-0" v-for="img, i in images" />
      </div>
    </div>

    <Shape class="position-absolute shape"/>
    <Shape class="position-absolute shape2"/>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vue from 'vue'
import Shape from '@/components/design/shape'
Vue.use(Viewer)

export default {
  props:['typeID', 'type'],
  components: {
    Shape
  },
  methods: {
    reportEvent(event) {
      this.$gtag('event', `open-image`, {
        event_category: 'Model Overview',
        event_label: event
      });
    }
  },
  data(){
    return {
      images:[],
      imageError: false,
      lightBoxOptions: JSON.parse(JSON.stringify({  "button": true, "navbar": true, "title": false, "toolbar": false, "tooltip": true, "movable": true, "zoomable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, })),
      swiperOption: {
          // slidesPerView: 3,
          slidesPerView: 'auto',
          spaceBetween: 0,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          autoplay: {
            delay: 2500,
            disableOnInteraction: false
          }
        }
    }
  },
  created(){
    var self = this;
    self.$axios.get('/api-car/getModelAfbeeldingen/nTypeID='+self.typeID+';cClient=30abad7b-0b3f-452d-ab65-20c7db9520e8;nFotoWidth=900;cFotoRatio=16-9').then((response)=>{
      self.images = response.data.getModelAfbeeldingenResult.filter(image=>{ return !image.cFotonaam.endsWith('.png')})
      if(self.images.length < 2 && self.images.find(img => img.cURL === 'https://media.autodisk.nl/fotos/geen.jpg' ))
      self.imageError = true
    });
  }
}
</script>

<style lang="css" lang="scss">
#gallery{
  padding-top: 0;
  position: relative;

  img.car{
    max-height: 293px;
  }

  .pattern-block{
    position: absolute;
    bottom: -20px;
    left: 0;
    z-index: 99;
  }

  .shape{
    z-index:999;
    bottom:-1px;
  }
  .shape2{
    transform: rotateY(180deg);
    z-index:999;
    opacity: 0.5;
    bottom:-1px;
  }
}
</style>
